import React, { useState } from "react";
import { buildApiUrl } from "../utils/apiConfig";
import UploadImageModal from "./UploadImageModal";
import "../styles/file-upload-modal.css";

interface ProfilePictureUploadProps {
    onUploadSuccess?: () => void;
    onUploadError?: (error: string) => void;
    className?: string;
}

const ProfilePictureUpload: React.FC<ProfilePictureUploadProps> = ({
    onUploadSuccess,
    onUploadError,
    className = "",
}) => {
    const [open, setOpen] = useState(false);

    return (
        <div className={className}>
            <button
                type="button"
                className="profile-picture-upload-trigger"
                onClick={() => setOpen(true)}
            >
                Change photo
            </button>

            <UploadImageModal
                open={open}
                onClose={() => setOpen(false)}
                mode="immediate"
                uploadUrl={buildApiUrl("api/profile/me/avatar")}
                title="Upload profile picture"
                onUploaded={() => {
                    setOpen(false);
                    onUploadSuccess?.();
                }}
            />
        </div>
    );
};

export default ProfilePictureUpload;
